module.exports = __webpack_public_path__ + "img/shared8.626bcfa2.png";